import React from 'react';
import MuiSwitch from '@material-ui/core/Switch';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'inline-flex',
    position: 'relative'
  },
  unsaved: {
    '&:after': {
      borderBottom: `2px solid ${theme.palette.secondary.main}`,
      bottom: 2,
      content: '""',
      left: 8,
      position: 'absolute',
      right: 8
    }
  }
}));

export function switchValuesMatch(checked, controllerValue) {
  return Boolean(checked) === (controllerValue === true || Number(controllerValue) === 1);
}

export default function SettingsSwitch({ controller_value, controls, settingPath, unsaved: unsavedOverride, ...other }) {
  controls?.retainSetting?.(settingPath ?? other.name);
  const classes = useStyles();
  const tracksControllerValue = controller_value !== undefined;
  const unsaved =
    unsavedOverride ??
    (tracksControllerValue && !switchValuesMatch(other.checked, controller_value));

  return (
    <span
      className={`${classes.root} ${unsaved ? classes.unsaved : ''}`.trim()}
      data-unsaved={unsaved ? 'true' : undefined}
    >
      <MuiSwitch {...other} />
    </span>
  );
}
